import { join } from 'lodash'

const toLines = strings => join(strings, '\n')

export default toLines
